import { FormIoState } from "./formio.model";

export interface FormSubmission {
    schemaId: number;
    schemaState: FormIoState;
    submission: {
        data: { [key: string]: any };
        metadata: any,
        state: FormSubmissionState;
        _vnote: string,
    };
    isAutoSave: boolean;
    version: string | undefined;
}

export enum FormSubmissionState {
    draft = "draft",
    submitted = "submitted"
}